'use strict';

var _objectWithoutProperties = require('babel-runtime/helpers/object-without-properties')['default'];

var _extends = require('babel-runtime/helpers/extends')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.makeClass = makeClass;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bem = require('./bem');

function makeClass(Component, bemName) {
    return function (_ref) {
        var children = _ref.children;
        var className = _ref.className;

        var props = _objectWithoutProperties(_ref, ['children', 'className']);

        var classNames = bemName;
        if (className) classNames += " " + className;

        return _react2['default'].createElement(
            Component,
            _extends({}, props, { className: classNames }),
            children
        );
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-blazecss/lib/utils/makeClass.js
 ** module id = 1034
 ** module chunks = 0
 **/